import { atom } from 'recoil';

/**
 * AI 질문 창(PC 작은 창·폰 시트)이 보여 줄 것 — 대화(`chatId` 가 null 이면 새 질문), 내 질문 목록,
 * 또는 공유받은 대화(`shareToken`, `/ai/s/:token`)
 */
export interface AiChatWindowTarget {
    view: 'chat' | 'history' | 'share';
    chatId: string | null;
    /** view 가 'share' 일 때만 */
    shareToken?: string | null;
    /** 새 질문 칸에 채워 둘 질문(보내지는 않는다) — 알림 링크 `/ai?ask=…`(맞춤 공고 알림의 "AI 추천") */
    fillQuestion?: string | null;
}

/**
 * "홈에서 AI 질문 창을 이 상태로 열어 달라"는 요청.
 * PC 에서 `/ai`·`/ai/:id`·`/ai/history`·`/ai/s/:token` 주소로 들어오면 그 화면이 요청을 남기고 홈으로 보내고,
 * 홈의 AI 버튼(HomeAiButton)이 요청을 꺼내 창을 연다. 꺼내면 바로 null 로 되돌린다.
 */
export const aiChatWindowRequestState = atom<AiChatWindowTarget | null>({
    key: 'aiChatWindowRequestState',
    default: null,
});

/**
 * 지금 열린 AI 대화 화면이 "쓸 수 없는 회원" 안내(면허 인증 전·이용 대상 아님)를 보여 주는 중인지.
 * 공유받은 대화를 이어서 물을 수 없는 사람(비회원·면허 인증 전 등)에게 보여 주는 중일 때도 true.
 * 대화 화면(AiChatView)이 쓰고, 머리줄(폰 시트·PC 창)이 읽어 [내 질문]·[새 질문] 을 숨긴다.
 */
export const aiChatBlockedState = atom<boolean>({
    key: 'aiChatBlockedState',
    default: false,
});
